import { Component } from '@angular/core';


export class SkyRepeaterItemTitleComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-repeater-item-title',
  template: `<ng-content></ng-content>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
